import { detectLocale, isAvailableLocale, type UserLocale } from '@leanin/shared';

const COOKIE = 'ui_locale';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  for (const part of document.cookie.split(';')) {
    const eq = part.indexOf('=');
    if (eq === -1) continue;
    if (part.slice(0, eq).trim() !== name) continue;
    return decodeURIComponent(part.slice(eq + 1).trim());
  }
  return null;
}

// Resolve the anonymous / pre-login UI locale: a previously-remembered choice
// wins, otherwise the browser's language list — both gated to
// AVAILABLE_LOCALES so we never select a language we'd render half-translated.
// The result is persisted to a cookie so it's stable across visits and can
// seed account creation once signup-side detection is wired.
export function detectBrowserLocale(): UserLocale {
  const remembered = readCookie(COOKIE);
  const resolved = isAvailableLocale(remembered)
    ? remembered
    : detectLocale(
        typeof navigator !== 'undefined'
          ? (navigator.languages?.join(',') ?? navigator.language)
          : null,
      );
  if (typeof document !== 'undefined') {
    document.cookie = `${COOKIE}=${resolved}; path=/; max-age=31536000; samesite=lax`;
  }
  return resolved;
}
